// A Needs you item opened over the page (Antonin, 15 Oct: "a modal for each"), so the list underneath never changes.
// What the draft carries: the patient (when it is one of today's visits), the visit's reason and date, and how late it
// is. The one action that exists in production is opening the encounter, where the note is reviewed and signed; it is
// the modal's one primary. Decline, Edit and an AI note are the prototype's, with no production source: not drawn.
import { Stethoscope } from 'lucide-react';
import { Button, Modal } from '@scripsteam/scrips-signal-ds';
import type { NeedItem } from './ready-list-data';

export interface NeedsYouModalProps {
  item: NeedItem | null;
  onClose: () => void;
  onOpenEncounter: (item: NeedItem) => void;
}

export function NeedsYouModal({ item, onClose, onOpenEncounter }: NeedsYouModalProps) {
  const lines = item
    ? [
        item.patientName ? { label: 'Patient', text: item.patientName } : null,
        item.reason ? { label: 'Reason', text: item.reason } : null,
        item.visit ? { label: 'Visit', text: item.visit } : null,
      ].filter((l): l is { label: string; text: string } => l != null)
    : [];
  return (
    <Modal
      open={item != null}
      onClose={onClose}
      title={item?.title ?? ''}
      size="sm"
      footer={
        <>
          <Button variant="secondary" size="md" onClick={onClose}>
            Close
          </Button>
          <Button variant="primary" size="md" data-open-encounter-need icon={<Stethoscope className="size-4" aria-hidden />} onClick={() => item && onOpenEncounter(item)}>
            Open encounter
          </Button>
        </>
      }
    >
      {item && (
        <div data-needs-modal className="need-modal">
          <p className="need-modal-line">
            <span className="need-due" data-tone={item.due.tone}>
              {item.due.text}
            </span>
            <span className="need-modal-kind">Unsigned note</span>
          </p>
          {lines.length > 0 && (
            <dl className="ready-brief-list">
              {lines.map((l) => (
                <div key={l.label} className="ready-brief-line">
                  <dt>{l.label}</dt>
                  <dd>{l.text}</dd>
                </div>
              ))}
            </dl>
          )}
        </div>
      )}
    </Modal>
  );
}
